import React from "react";
import { useCookies } from 'react-cookie';

const CtaReferrer = ({ register }) => {
    const [cookies] = useCookies()
    const { cta_referrer } = cookies
    return(
        <input {...register("cta_referrer")} type="hidden" name="cta_referrer" id="cta_referrer" value={cta_referrer} />
    )
}

export default React.memo(CtaReferrer)